import { ThunkAction } from 'redux-thunk';
import { RootState } from 'store';
import { RootAction } from 'types/Actions';
import { AlertScreen, AlertVariant } from 'types/Alert';
import { v4 as uuid } from 'uuid';
import {
    ADD_ALERT,
    AlertsAction,
    CLEAR_ALERT,
    REMOVE_ALERT,
    REMOVE_ALERTS_BY_SCREEN
} from './AlertsActionsTypes';

export const addAlertThunk = (
    text: string | React.ReactNode,
    screen?: AlertScreen,
    variant?: AlertVariant
): ThunkAction<void, RootState, null, RootAction> => {
    return dispatch => {
        dispatch(addAlert(text, screen, variant));
    };
};

export const removeAlertThunk = (
    alertUuid: string
): ThunkAction<void, RootState, null, RootAction> => {
    return dispatch => {
        dispatch(removeAlert(alertUuid));
    };
};

export const removeAlertsByScreenThunk = (
    screen: AlertScreen
): ThunkAction<void, RootState, null, RootAction> => {
    return dispatch => {
        dispatch(removeAlertsByScreen(screen));
    };
};

export const clearAlertsThunk = (): ThunkAction<void, RootState, null, AlertsAction> => {
    return dispatch => {
        dispatch(clearAlerts());
    };
};

const addAlert = (
    text: string | React.ReactNode,
    screen?: AlertScreen,
    variant?: AlertVariant
): AlertsAction => ({
    type: ADD_ALERT,
    payload: {
        alert: {
            uuid: uuid(),
            text,
            screen,
            variant: variant || AlertVariant.Default
        }
    }
});

export const removeAlert = (alertUuid: string): AlertsAction => ({
    type: REMOVE_ALERT,
    payload: {
        uuid: alertUuid
    }
});

const clearAlerts = (): AlertsAction => ({
    type: CLEAR_ALERT
});

const removeAlertsByScreen = (screen: AlertScreen): AlertsAction => ({
    type: REMOVE_ALERTS_BY_SCREEN,
    payload: {
        screen
    }
});
